(function () {
  class Affiliate {
    partners = [
      { partner: 'awin', key: 'awc', dtl: 30 },
      { partner: 'tradedoubler', key: 'tduid', dtl: 30 },
      { partner: 'adtraction', key: 'at_gd', dtl: 30 },
      { partner: 'rakuten', key: 'ranSiteID', dtl: 30 }
    ]

    set () {
      const urlParams = new URLSearchParams(window.location.search)
      const partnerConfig = this.partners.find((aff) => !!urlParams.get(aff.key));
      if (partnerConfig) {
        window.localStorage.setItem('affiliatePartner', partnerConfig.partner);
        window.localStorage.setItem('affiliateId', urlParams.get(partnerConfig.key));
        window.localStorage.setItem('affiliateLandDate', new Date().getTime());
        window.localStorage.setItem('affiliateValidUntil', new Date().getTime() + 1000 * 60 * 60 * 24 * partnerConfig.dtl);
      }
    }

    get () {
      const affiliatePartner = window.localStorage.getItem('affiliatePartner');
      if (!affiliatePartner) {
        return {};
      }

      const partnerConfig = this.partners.find((aff) => aff.partner === affiliatePartner);
      if (!partnerConfig) {
        return {};
      }

      const validUntil = window.localStorage.getItem('affiliateValidUntil');
      let validUntilNumber = parseInt(validUntil);
      if (!validUntilNumber) {
        validUntilNumber = new Date().getTime() + 1000 * 60 * 60 * 24 * partnerConfig.dtl;
        window.localStorage.setItem('affiliateValidUntil', validUntilNumber);
      }
      if (validUntilNumber && new Date().getTime() < validUntilNumber) {
        return {
          partner: affiliatePartner,
          id: window.localStorage.getItem('affiliateId'),
          landDate: window.localStorage.getItem('affiliateLandDate')
        };
      }

      return {};
    }

    clear () {
      window.localStorage.removeItem('affiliatePartner');
      window.localStorage.removeItem('affiliateId');
      window.localStorage.removeItem('affiliateLandDate');
      window.localStorage.removeItem('affiliateValidUntil');
    }
  }
  const affiliate = new Affiliate();

  let debounceTimer;
  const setCartAttributes = function (attributes) {
    if (debounceTimer) {
      clearTimeout(debounceTimer)
    }
    debounceTimer = setTimeout(() => {
      window.updateCart({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes
        })
      })
    }, 100)
  }

  const removeTiktokCookies = function () {
    const removedCookies = [
      ...(window.removeCookie('ttclid') ? ['ttclid'] : []),
      ...(window.removeCookie('_ttp') ? ['_ttp'] : [])
    ];
    window.removeCookie('_tt_enable_cookie');
    if (removedCookies.length > 0) {
      setCartAttributes(
        removedCookies
          .map((c) => c.startsWith('_') ? c : `_${c}`)
          .reduce((prev, cookie) => {
            return { ...prev, [cookie]: '' }
          }, {})
      );
    }
  }

  window.addEventListener('CookiebotOnConsentReady', () => {
    if (window.Cookiebot.consent.marketing) {
      affiliate.set();
    } else {
      removeTiktokCookies();
      affiliate.clear();
    }
  })

  document.addEventListener('DOMContentLoaded', () => {
    let consentStatus
    const consentCookie = document.cookie.split(';')
      .find((cookie) => cookie.trim().startsWith('_tracking_consent='))

    if (consentCookie) {
      const decodedContent = decodeURIComponent(consentCookie.split('=')[1])
      const consentObject = JSON.parse(decodedContent);

      if (typeof consentObject.con.GDPR !== 'undefined') {
        consentStatus = consentObject.con.GDPR
      } else {
        consentStatus = consentObject.con.CMP.m
      }
    } else {
      consentStatus = 1
    }

    if (consentStatus === 1 || consentStatus === '1') {
      affiliate.set();
    } else {
      removeTiktokCookies();
      affiliate.clear();
    }
  })

  document.addEventListener('cart:fetch', (event) => {
    let updateAttributes = {};
    const affiliateValue = affiliate.get();
    if (affiliateValue.partner !== event.detail?.attributes?._affiliate_partner) {
      updateAttributes = { ...updateAttributes, _affiliate_partner: affiliateValue.partner ?? '' }
    }
    if (affiliateValue.id !== event.detail?.attributes?._affiliate_id) {
      updateAttributes = { ...updateAttributes, _affiliate_id: affiliateValue.id ?? '' }
    }
    if (affiliateValue.landDate !== event.detail?.attributes?._land_date) {
      updateAttributes = { ...updateAttributes, _land_date: affiliateValue.landDate ?? '' }
    }
    const _ttp = window.getCookieValue('_ttp') || undefined;
    if (_ttp !== event.detail?.attributes?._ttp) {
      updateAttributes = { ...updateAttributes, _ttp: _ttp ?? '' }
    }
    const _ttclid = window.getCookieValue('ttclid') || undefined;
    if (_ttclid !== event.detail?.attributes?._ttclid) {
      updateAttributes = { ...updateAttributes, _ttclid: _ttclid ?? '' }
    }

    if (Object.keys(updateAttributes).length > 0) {
      setCartAttributes(updateAttributes)
    }
  })

  if (window.location.pathname === window.routes.cart_url) {
    window.fetchCart();
  }
})();
